import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { exists, isValidArray } from '../../../helpers';
import Text from '../Text';
import Styles from './TextInput.styles';
// import { DateRange } from "react-date-range";
// import ru from "date-fns/esm/locale";
// import "react-date-range/dist/styles.css";
// import "react-date-range/dist/theme/default.css";
// import RangePicker from "react-range-picker";
// import RangePicker from "react-range-picker";
// import Calendar from '../Calendar/Calendar';

// import { DateRangePicker } from 'react-date-range';
// import { DateRange } from 'react-date-range';
// import 'react-date-range/dist/styles.css'; // main css file
// import 'react-date-range/dist/theme/default.css'; // theme css file


const Wrapper = styled.div`${Styles.wrapper}`; // prettier-ignore
const SelectWrapper = styled.div`${Styles.selectWrapper};`; // prettier-ignore
const Select = styled.select`${Styles.select}`; // prettier-ignore
const Input = styled.input`${Styles.input}`;
const SelectArrow = styled.div`${Styles.selectArrow};`; // prettier-ignore
const Name = styled(Text).attrs({ bold: true })`${Styles.name}`; // prettier-ignore
const Title = styled(Text).attrs({ bold: true })`${Styles.title}`; // prettier-ignore
const InputRounder = styled.input`${Styles.inputRounder}`; // prettier-ignore
const LabelInput = styled(Text).attrs({ bold: true })`${Styles.labelInput}`; // prettier-ignore
const InputsWrapper = styled.div`${Styles.inputsWrapper};`; // prettier-ignore
const SelectWrapperTitle = styled.div`${Styles.selectWrapperTitle};`; // prettier-ignore
/**
 * OptionsInput component
 * @param {string} className - modifier class
 * @param {string} defaultValue - default valu for select box
 * @param {string} name - input's name
 * @param {Array} options - input's options
 * @param {string} color - optional color
 * @param {bool} isSorting - true if its a sorting select
 * @returns {?JSX}
 */
const OptionsInput = ({
  className, name, options, onChange, width, value, hasBlackTheme, color, isSorting, calendar, min, textColor, max, inputName, status
}) => {
  if (!exists(name) || !isValidArray(options)) return null;

  const getColor = (status) => {
    return status == 1 ? 'green' : 'red';
  }
 
  return (
    <Wrapper className={className} hasBlackTheme={hasBlackTheme} isSorting={isSorting}>
      <InputsWrapper marginRight={"30px"}>
      <LabelInput>{name}</LabelInput>
            <InputRounder  width={width || "auto"}  placeholder={name}/>
          </InputsWrapper>
    </Wrapper>
  );
};

OptionsInput.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  onChange: PropTypes.func,
  value: PropTypes.string,
  hasBlackTheme: PropTypes.bool,
  isSorting: PropTypes.bool,
  color: PropTypes.string,
  textColor: PropTypes.string,
  calendar: PropTypes.bool,
  min: PropTypes.string,
  max: PropTypes.string,
  inputName: PropTypes.string
};

export default OptionsInput;
